import React from "react";
import { withRouter } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import SidebarNavList from "./sidebar-nav-list.jsx";
import menus from "./menu.jsx";
import { menuMatchesLocation } from "./menuMatch.js";
import { clearAuthData } from "../content/axiosConfig.js";

const SECTIONS = [
  { key: "menu", label: "Menu" },
  { key: "general", label: "General" },
];

class SidebarNav extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);
    this.baseMenus = menus.map((m) => ({ ...m, search: false }));
    this.state = {
      active: -1,
      clicked: -1,
      menus: this.baseMenus,
    };

    this.handleSidebarSearch = this.handleSidebarSearch.bind(this);
  }

  handleExpand(e, i, match) {
    e.preventDefault();

    if (this.state.clicked === -1 && match) {
      this.setState(() => ({
        active: -1,
        clicked: 1,
      }));
    } else {
      this.setState(() => ({
        active: this.state.active === i ? -1 : i,
        clicked: 1,
      }));
    }
  }

  handleLogout = (toggleAppSidebarMobile) => {
    if (window.innerWidth <= 768 && toggleAppSidebarMobile) {
      toggleAppSidebarMobile({
        preventDefault: () => {},
        stopPropagation: () => {},
        target: null,
      });
    }

    setTimeout(() => {
      clearAuthData();
      window.location.href = "/user/login";
    }, 200);
  };

  handleSidebarSearch(e) {
    let searchValue = e.target.value;
    searchValue = searchValue.toLowerCase();

    this.setState(() => {
      let newMenus = [];
      if (searchValue !== "") {
        newMenus = this.baseMenus.filter((item) => {
          let title = item.title;
          title = title.toLowerCase();
          if (title.search(searchValue) > -1) {
            item.search = true;
            return true;
          }
          if (item.children) {
            for (var i = 0; i < item.children.length; i++) {
              let title2 = item.children[i]["title"];
              title2 = title2.toLowerCase();

              if (title2.search(searchValue) > -1) {
                item.search = true;
                return true;
              }
            }
          }
          return false;
        });
      } else {
        newMenus = this.baseMenus.map((item) => ({ ...item, search: false }));
      }
      return {
        menus: newMenus,
      };
    });
  }

  renderSection(sectionKey, label) {
    const sectionMenus = this.state.menus.filter(
      (m) => (m.section || "menu") === sectionKey
    );
    if (sectionMenus.length === 0) return null;

    return (
      <React.Fragment key={sectionKey}>
        <div className="menu-header">{label}</div>
        {sectionMenus.map((menu, i) => {
          const globalIndex = this.state.menus.indexOf(menu);
          const menuRouteMatch = menuMatchesLocation(
            this.props.location.pathname,
            menu
          );
          return (
            <SidebarNavList
              data={menu}
              key={menu.path || i}
              expand={(e) => this.handleExpand(e, globalIndex, menuRouteMatch)}
              active={globalIndex === this.state.active}
              clicked={this.state.clicked}
            />
          );
        })}
      </React.Fragment>
    );
  }

  renderLogout(toggleAppSidebarMobile) {
    return (
      <div className="donezo-sidebar-footer">
        <div
          className="menu-item donezo-logout-item"
          role="button"
          tabIndex={0}
          onClick={() => this.handleLogout(toggleAppSidebarMobile)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              this.handleLogout(toggleAppSidebarMobile);
            }
          }}
        >
          <span className="menu-link">
            <div className="menu-icon">
              <i className="fa-solid fa-right-from-bracket"></i>
            </div>
            <div className="menu-text">Log out</div>
          </span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <AppSettings.Consumer>
        {({ appSidebarSearch, toggleAppSidebarMobile }) => (
          <div className="menu donezo-sidebar-menu-wrap">
            <PerfectScrollbar
              className="donezo-sidebar-menu-scroll"
              options={{ suppressScrollX: true, wheelPropagation: false }}
            >
              {appSidebarSearch && (
                <div className="menu-search mb-n3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Sidebar menu filter..."
                    onKeyUp={this.handleSidebarSearch}
                  />
                </div>
              )}
              {SECTIONS.map(({ key, label }) =>
                this.renderSection(key, label)
              )}
            </PerfectScrollbar>
            {this.renderLogout(toggleAppSidebarMobile)}
          </div>
        )}
      </AppSettings.Consumer>
    );
  }
}

export default withRouter(SidebarNav);
